angular.module('mercury.modules.stock.purchaseorder')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.PurchaseorderActive', {
    url: '/purchaseorder/active',
    templateUrl: 'modules/stock/purchaseorder/active.tpl.html',
    controller: 'StockPurchaseorderActiveCtrl'
  });

  $stateProvider.state('Stock.PurchaseorderActiveEdit', {
    url: '/purchaseorder/active/edit/:id?:return',
    templateUrl: 'modules/stock/purchaseorder/edit.tpl.html',
    controller: 'StockPurchaseorderEditCtrl',
    data: {
      menuLinkState: 'Stock.PurchaseorderActive'
    }
  });

  $stateProvider.state('Stock.PurchaseorderExport', {
    url: '/purchaseorder/export?report',
    templateUrl: 'modules/stock/purchaseorder/export.tpl.html',
    controller: 'StockPurchaseorderExportCtrl',
    data: {
      menuLinkState: 'Stock.ReportSupplier'
    }
  });

  $stateProvider.state('Stock.PurchaseorderHistory', {
    url: '/purchaseorder/history',
    templateUrl: 'modules/stock/purchaseorder/history.tpl.html',
    controller: 'StockPurchaseorderHistoryCtrl'
  });

  $stateProvider.state('Stock.PurchaseorderActive.Validate', {
    url: '/validate/:id',
    data: {
      menuLinkState: 'Stock.PurchaseorderActive',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/validate.tpl.html',
        controller: 'StockPurchaseorderValidateCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.PurchaseorderActive.SendEmail', {
    url: '/sendemail/:id',
    data: {
      menuLinkState: 'Stock.PurchaseorderActive',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/sendemail.tpl.html',
        controller: 'StockPurchaseorderSendemailCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.PurchaseorderActive.SendFax', {
    url: '/sendfax/:id',
    data: {
      menuLinkState: 'Stock.PurchaseorderActive',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/sendfax.tpl.html',
        controller: 'StockPurchaseorderSendfaxCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.PurchaseorderActive.SendDirect', {
    url: '/senddirect/:id',
    data: {
      menuLinkState: 'Stock.PurchaseorderActive',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/senddirect.tpl.html',
        controller: 'StockPurchaseorderSenddirectCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });
}]);
